import SelectFilter from './SelectFilter';

export default class DepartmentFilter extends SelectFilter {
  type = 'department';

  apply(locationsToFilter, filters) {
    this.isActive = true;

    const filteredLocations = locationsToFilter.filter((location) => (filters?.vehicleType?.isSet()
      ? location.hasDepartmentWithVehicleType(
        this.value,
        filters.vehicleType.value,
      )
      : location.hasDepartment(this.value)));

    return filteredLocations;
  }
}
